import React, {ReactNode} from 'react'
import {InfoCircleOutlined} from '@ant-design/icons'
import styles from './InfoHint.scss'

interface InfoHintProps {
    children: ReactNode
}

export const InfoHint: React.FC<InfoHintProps> = ({children}) => {
    return (
        <div className={styles.infoHint}>
            <InfoCircleOutlined className={styles.infoHintIcon} />
            <span>{children}</span>
        </div>
    )
}
